export default __webpack_public_path__ + "static/media/portfolio.044ddd8c.svg";